import type { Meta, StoryObj } from "@storybook/react";

import type { BulletItemProps } from "@/ui/core/BulletItem";
import BulletItem from "@/ui/core/BulletItem";
import { VStack } from "@/ui/layout";

const StoryMeta: Meta<BulletItemProps> = {
  title: "Core/BulletItem",
  component: BulletItem,
  argTypes: {
    text: { control: "text" },
  },
  args: {
    testID: "bullet-item",
    text: "This is a bullet item example",
  },
};

type Story = StoryObj<BulletItemProps>;

const Primary: Story = {};

const MultipleBullets: Story = {
  render: () => (
    <VStack gap={8} width="100%">
      <BulletItem testID="bullet-1" text="First bullet item" />
      <BulletItem
        testID="bullet-2"
        text="Second bullet item with longer text to demonstrate wrapping behavior"
      />
      <BulletItem testID="bullet-3" text="Third bullet item" />
    </VStack>
  ),
};

export { MultipleBullets, Primary };
export default StoryMeta;
